module.exports = __webpack_public_path__ + "img/img3.801fa6d2.png";